import { memo } from "react";
import { MdSearch } from "react-icons/md";

import HeaderIconButton from "@/components/Core/HeaderIconButton";
import { useSiteSearch, useTranslate } from "@/hooks";

/** Opens the search dialog (games and matches); on a phone the bottom bar has it instead. */
const SearchButton = () => {
  const t = useTranslate();
  const { isOpen, open } = useSiteSearch();

  return (
    <HeaderIconButton label={t("search.title")} active={isOpen} onClick={() => open()}>
      <MdSearch aria-hidden />
    </HeaderIconButton>
  );
};

export default memo(SearchButton);
